<script setup>
import defineProps from "vue";

defineProps({
  name: String,
  title: String,
  content: String,
  image: String
})
</script>

<template>
  <div class="secondary-item rounded-4 my-5">
    <img src="@/assets/images/logo-sm.png" alt="" class="logo"/>
    <div class="row align-items-stretch">
      <div class="col-md-4 d-flex flex-column justify-content-end text-center mb-4 mb-md-0">
        <img
            :src="image"
            :alt="name"
            class="img-fluid rounded bottom-image"
        />
      </div>
      <div class="col-md-8 d-flex align-items-center">
        <div class="p-4 w-100">
          <h5 class="mb-3">
            {{ title }}
          </h5>
          <p>
            {{ content }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.secondary-item {
  background-color: $color-pink-lighter;
  color: $color-purple;
  position: relative;

  .logo {
    position: absolute;
    top: 10px;
    left: 10px;
    max-width: 40px;
  }

  h5 {
    color: $color-purple;
  }

  p {
    line-height: 1.6;
    color: $color-purple;
  }

  .col-md-4 {
    display: flex;
    flex-direction: column;
  }

  .bottom-image {
    margin-top: auto;
    max-height: 500px;
    object-fit: contain;
  }
}
</style>
